/**
 * @generated SignedSource<<1293a719c3205311a3ca6ad2204666e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamButtonDataConnectedComponent$data = {
  readonly edges: ReadonlyArray<{
    readonly id: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "TeamButtonDataConnectedComponent";
};
export type TeamButtonDataConnectedComponent$key = {
  readonly " $data"?: TeamButtonDataConnectedComponent$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamButtonDataConnectedComponent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TeamButtonDataConnectedComponent",
  "selections": [
    {
      "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    }
  ],
  "type": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection"
};

(node as any).hash = "25d8f58c6ced810f9ccfddf383d8d70f";

export default node;
